
        var result = require("!!../../css-loader/index.js!./primeng.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/primeng.css
// module id = 477
// module chunks = 1